export const getLanguageFromLocale = (locale: string): string => {
    if (!locale.includes("-")) {
        return locale;
    }
    return locale.split("-")[0];
};

export const getCountryFromLocale = (locale: string): string => {
    if (!locale.includes("-")) {
        return null;
    }
    return locale.split("-")[1];
};
